import {formatter, request} from "@/utils/request";
import {ButtonArgs} from "@/components/WdiBus/Buttons/data";

export namespace FormSp {
  export const Path = {
    get: "/expenseapi/formSp/getFormSp",
    getVo: "/expenseapi/formSp/getFormSpVo",
    getPreFormSp: "/expenseapi/formSp/getPreFormSp",
    paymentPrev: "/expenseapi/formSp/paymentPrev",
    ExistsFormSPByRebateInfo: "/expenseapi/formSp/existsFormSpByRebateInfo",
    GetSap: '/expenseapi/formSp/getSap',
    GetProductPrice: '/expenseapi/formSp/getProductPrice',
    PrintUrl: '/reportapi/print/formSpPrint',
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSp>>(Path.get, formatter(options));
  }

  export async function getVo(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSp>>(Path.getVo, formatter(options));
  }

  export async function paymentPrev(body: API.PaymentPrev) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    };
    return request<API.ResponseResult<API.PaymentPrev>>(Path.paymentPrev, formatter(options));
  }

  export async function existsFormSPByRebateInfo(rebateInfoId: number) {
    const options = {
      method: 'GET',
      body: {
        id: rebateInfoId
      },
    };
    return request<API.ResponseResult<boolean>>(Path.ExistsFormSPByRebateInfo, formatter(options));
  }

  export async function getPreFormSp(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSp>>(Path.getPreFormSp, formatter(options));
  }

  export async function getSap(supplierCode: string) {
    const options = {
      method: 'GET',
      body: {
        supplierCode: supplierCode,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.GetSap, formatter(options));
  }

  export async function getProductPrice(body: API.ProductPriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormGoodsDetail>>(Path.GetProductPrice, formatter(options));
  }

  export namespace Buttons {
    export const Path = {
      ValidateDetail: '/expenseapi/spButtons/validateDetail',
      ValidateGoods: '/expenseapi/spButtons/validateGoods',
      Apply: '/expenseapi/spButtons/apply',
      Delete: '/expenseapi/spButtons/delete',
      Get: '/expenseapi/spButtons/get',
      BUDGET_INFOS: '/expenseapi/spButtons/budgetInfos',
      WARNING_INFOS: '/expenseapi/spButtons/warningInfos',
      COUNT_OF_WARNING: '/expenseapi/spButtons/countOfWarning',
      DYNAMIC_INFOS: '/expenseapi/spButtons/dynamicInfos',
      CompleteDelivery: '/expenseapi/spButtons/completeDelivery',
      ModifyAmount: '/expenseapi/spButtons/modifyAmount',
      getSfaResultUrl: '/expenseapi/spButtons/getSfaResultUrl',
      ModifyPrepay: '/expenseapi/spButtons/modifyPrepay',
      AllowViewSfaCollectionDetails: '/expenseapi/spButtons/allowViewSfaCollectionDetails',
      ViewSfaCollectionDetails: '/expenseapi/spButtons/viewSfaCollectionDetails',
      downloadModifyAmountTemplate: '/expenseapi/spButtons/downloadModifyAmountTemplate',
    };

    export async function get(body: API.ButtonArgs) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };

      return request<API.ResponseResult<API.Button>>(Path.Get, formatter(options));
    };

    export async function modifyAmount(body: { pageTypeId: number, formSpDetail: any, }) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };
      return request<API.ResponseResult<any>>(Path.ModifyAmount, formatter(options));
    };

    export async function modifyPrepay(body: any) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };
      return request<API.ResponseResult<any>>(Path.ModifyPrepay, formatter(options));
    };

    export async function validateDetail(body: {
      rowIndex: number,
      form: any,
      formSp: any,
      formSpDetail: any,
      formSpDetails: any[],
    }) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSpDetailApprovalView>>(Path.ValidateDetail, formatter(options));
    };

    export async function validateGoods(body: {
      rowIndex: number,
      pageTypeId: number,
      formGoods: any,
      formGoodsList: any[],
    }) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormGoodsVo>>(Path.ValidateGoods, formatter(options));
    };

    export async function apply(body: {
      form: API.Form,
      formSp: API.FormSp,
      formSpDetails: API.FormSpDetail[],
      formGoods?: API.FormGoodsVo[],
      invoices?: API.FormInvoiceVo[],
      formSpAdvances?: API.FormSpAdvance[],
    }) {
      const options = {
        method: 'POST',
        body: {
          ...body
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.Apply, formatter(options));
    };

    export async function del(formId: number) {
      const options = {
        method: 'POST',
        body: {
          formId: formId
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.Delete, formatter(options));
    };

    export async function budgetInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {formId}
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.BUDGET_INFOS, formatter(options));
    };

    export async function warningInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.WARNING_INFOS, formatter(options));
    }

    export async function countOfWarning(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<number>>(Path.COUNT_OF_WARNING, formatter(options));
    }

    export async function dynamicInfos(formId: number) {
      const options = {
        method: 'Get',
        body: {formId}
      };
      return request<API.DynamicInformation[]>(Path.DYNAMIC_INFOS, formatter(options));
    };

    export async function completeDelivery(body: API.ButtonArgs) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<any>>(Path.CompleteDelivery, formatter(options));
    };

    export async function getSfaResultUrl(formId: number, formSpDetailId: number) {
      const options = {
        method: 'GET',
        body: {formId, formSpDetailId}
      };
      return request<API.ResponseResult<string>>(Path.getSfaResultUrl, formatter(options));
    };

    export async function allowViewSfaCollectionDetails(id: number) {
      const options = {
        method: 'GET',
        body: {
          id: id
        },
      };
      return request<API.ResponseResult<boolean>>(Path.AllowViewSfaCollectionDetails, formatter(options));
    }

    export async function viewSfaCollectionDetails(body: ButtonArgs) {
      const options = {
        method: 'POST',
        body: {
          ...body
        },
      };
      return request<API.ResponseResult<string>>(Path.ViewSfaCollectionDetails, formatter(options));
    }
  }
}

export namespace FormSpDetail {
  const Path = {
    GetFormSpDetailsForSaApply: "/expenseapi/formSp/getFormSpDetailsForSaApply",
    GetFormSpDetailsForSaBatchApply: "/expenseapi/formSp/getFormSpDetailsForSaBatchApply",
    GetFormSpDetailsForSaApplySelect: "/expenseapi/formSp/getFormSpDetailsForSaApplySelect",
    GetFormSpDetailsForSaApproval: "/expenseapi/formSp/getFormSpDetailsForSaApproval",
    GetsForFreeGoodsApply: "/expenseapi/formSp/getFormSpDetailsForFreeGoodsApply",
    GetsForFreeGoodsApproval: "/expenseapi/formSp/getFormSpDetailsForFreeGoodsApproval",
    GetsForRebate: "/expenseapi/formSp/getFormSpDetailsForRiApply",
    GetsForExpenseNonTpm: "/expenseapi/formSp/getFormSpDetailsForEiApply",
    GetSoldToCodes: "/expenseapi/formSp/getSoldToCodes",
    GetFormSpDetails: "/expenseapi/formSp/getFormSpDetails",
    GetFormSpPreDetailsVo: "/expenseapi/formSp/getFormSpPreDetailsVo",
    QueryFormSpDetailsForSelect: '/reportapi/sp/queryFormSpDetailsForSelect',
  }

  export async function getFormSpDetails(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSpDetail[]>>(Path.GetFormSpDetails, formatter(options));
  }

  export async function getFormSpDetailsForSaApply(body: API.FormSpDetailApplyParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetFormSpDetailsForSaApply, formatter(options));
  }

  export async function getFormSpDetailsForSaBatchApply(body: API.FormSpDetailApplyParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetFormSpDetailsForSaBatchApply, formatter(options));
  }

  export async function getFormSpDetailsForSaApplySelect(formSaDetailIds: string) {
    const options = {
      method: 'GET',
      body: {
        formSaDetailIds: formSaDetailIds,
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetFormSpDetailsForSaApplySelect, formatter(options));
  }

  export async function getFormSpDetailsForSaApproval(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetFormSpDetailsForSaApproval, formatter(options));
  }

  export async function getsForFreeGoodsApply(body: API.FormSpDetailApplyParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApplyView[]>>(Path.GetsForFreeGoodsApply, formatter(options));
  }

  export async function getsForFreeGoodsApproval(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetsForFreeGoodsApproval, formatter(options));
  }

  export async function getsForRebate(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetsForRebate, formatter(options));
  }

  export async function getsForExpenseNonTpm(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormSpDetailApprovalView[]>>(Path.GetsForExpenseNonTpm, formatter(options));
  }

  export async function getSoldToCodes(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<string[]>>(Path.GetSoldToCodes, formatter(options));
  }

  export async function queryFormSpDetailsForSelect(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.FormSpDetailApprovalView[]>>(Path.QueryFormSpDetailsForSelect, formatter(options));
  }
}

export namespace FormGoods {
  export const Path = {
    getFormGoodsForApply: "/expenseapi/formSp/getFormGoodsForApply"
  }

  export async function getForApply(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<API.FormGoodsVo[]>>(Path.getFormGoodsForApply, formatter(options));
  }
}

export namespace FormGoodsShipping {
  export const Path = {
    getFormGoodsShipping: "/expenseapi/formSp/getFormGoodsShipping",
    getFormGoodsShippings: "/expenseapi/formSa/getFormGoodsShippings"
  }

  export async function getFormGoodsShipping(formGoodsId: number) {
    const options = {
      method: 'GET',
      body: {
        formGoodsId: formGoodsId
      },
    };
    return request<API.ResponseResult<API.FormGoodsShippingView[]>>(Path.getFormGoodsShipping, formatter(options));
  }

  export async function getFormGoodsShippings(formSaDetailId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaDetailId: formSaDetailId
      },
    };
    return request<API.ResponseResult<API.FormGoodsShippingView[]>>(Path.getFormGoodsShippings, formatter(options));
  }
}

export namespace FormSpAdvance {
  export const Path = {
    GetFormSpAdvances: "/expenseapi/formSp/getFormSpAdvances"
  }

  export async function getFormSpAdvances(formId: number) {
    const options = {
      method: 'GET',
      body: {
        id: formId
      },
    };
    return request<API.ResponseResult<API.FormSpAdvance[]>>(Path.GetFormSpAdvances, formatter(options));
  }
}

export namespace ReversePrepayDetail {
  export const Path = {
    QueryReversePrepay: "/thirdpartyapi/hec/queryReversePrepay",
  }

  export async function queryReversePrepay(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.ReversePrepayDetailVo>>(Path.QueryReversePrepay, formatter(options));
  }
}
